import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useAuth0 } from '@auth0/auth0-react';

import TimesheetViewRow from './TimesheetViewRow';
import TimesheetEditRow from './TimesheetEditRow';
import { timesheetActions } from '../../../store';
import useReadOnlyTimesheetView from '../../../hooks/useReadOnlyTimesheetView';

import type { RootState } from '../../../store';
import type { ITimesheetTransformedData } from '../../../utils/types';

interface ITimesheetRow {
  timesheet: ITimesheetTransformedData;
}

const TimesheetRow = ({ timesheet }: ITimesheetRow) => {
  const { id: timesheetId } = timesheet;
  const dispatch = useDispatch();
  const { getAccessTokenSilently } = useAuth0();
  const { editingTimesheetId } = useSelector((state: RootState) => state.timesheets);

  const isReadOnlyView = useReadOnlyTimesheetView();

  const [editMode, setEditMode] = useState<boolean>(timesheetId ? false : true);

  useEffect(() => {
    if (editingTimesheetId !== timesheetId) return;

    if (!editMode) {
      dispatch(timesheetActions.updateState({ key: 'editingTimesheetId', value: null }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editMode, editingTimesheetId]);

  const handleModeChange = () => {
    setEditMode(true);
    dispatch(timesheetActions.updateState({ key: 'editingTimesheetId', value: timesheetId }));
  };

  const handleRemove = () => {
    dispatch(timesheetActions.remove({ id: timesheetId, getAccessTokenSilently }));
  };

  const handleCancel = () => {
    if (!timesheetId) return;
    setEditMode(false);
  };

  return editMode && !isReadOnlyView && !timesheet.read_only ? (
    <TimesheetEditRow timesheet={timesheet} onClose={handleCancel} />
  ) : (
    <TimesheetViewRow
      timesheet={timesheet}
      onModeChange={handleModeChange}
      onRemove={handleRemove}
    />
  );
};

export default TimesheetRow;
